import React from 'react';
import { Link } from 'react-router-dom';
export function WizardHeader() {
  return <header className="bg-white border-b border-gray-100 py-4" data-id="element-306">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-307">
        <Link to="/" className="text-2xl font-serif font-bold text-text-primary tracking-tight hover:text-accent transition-colors" data-id="element-308">
          HemNoMore
        </Link>
        <Link to="/" className="text-sm font-medium text-text-muted hover:text-text-primary transition-colors" data-id="element-309">
          Back to Home
        </Link>
      </div>
    </header>;
}